export enum TransactionsMenuEnum {
    overview = 0,
    property_transaction,
    unit_transaction
}
